// import Home from "pages/Home";
import Home from "pages/LandingPages/Home";
export default function HomePage() {
  return <Home />;
}
